module.exports = __webpack_public_path__ + "img/12_88.f42e72d4.png";